module.exports = __webpack_public_path__ + "static/media/client-tags.6a860486.svg";